import { TrophyIcon } from 'lucide-react';

interface CashSnapWinnerBadgeProps {
  isWinner: boolean;
  className?: string;
}

export default function CashSnapWinnerBadge({ isWinner, className = '' }: CashSnapWinnerBadgeProps) {
  if (!isWinner) return null;
  
  return (
    <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 ${className}`}>
      <TrophyIcon className="h-3.5 w-3.5 mr-1" />
      Winner
    </div>
  );
}